
import { StartContainer } from "./StartContainer";

interface StartMainContainerProps {
  userEmail: string | null;
  onGameStart: (email?: string) => void;
  onViewPreviousResults: () => void;
  hasCompletedToday: boolean;
  isLoading?: boolean;
  onClearCompletedStatus?: () => void;
}

export function StartMainContainer({ 
  userEmail, 
  onGameStart, 
  onViewPreviousResults, 
  hasCompletedToday,
  isLoading = false,
  onClearCompletedStatus
}: StartMainContainerProps) {
  console.log("StartMainContainer rendering with props:", { 
    hasEmail: !!userEmail, 
    userEmailValue: userEmail,
    hasCompletedToday,
    isLoading 
  });
  
  // Improved game start handler with more detailed logging
  const handleGameStart = (email?: string) => {
    const emailToUse = email || userEmail;
    console.log("StartMainContainer: Forwarding game start request with email:", emailToUse);
    
    // Make sure we're passing the email correctly
    onGameStart(emailToUse || "");
  };
  
  return (
    <StartContainer
      userEmail={userEmail}
      onGameStart={handleGameStart}
      onViewPreviousResults={onViewPreviousResults}
      hasCompletedToday={hasCompletedToday}
      isLoading={isLoading}
      onClearCompletedStatus={onClearCompletedStatus}
    />
  );
}
